<template>
  <div class="game_card_con">
    <NewPackChip v-if="hasNew" :title="$t('app.new_mode')" variant="yellow" />
    <NewPackChip
      v-if="hasNewGame"
      :title="$t('app.new')"
      variant="button-blue"
    />

    <NuxtLinkLocale
      class="game_card d-flex-column align-start space-between gap-20"
      :class="[slug, disabled && 'card_disabled']"
      :to="link"
      @mouseenter.native="$device.$isMobile ? null : handleArrowEvent('inside')"
      @mouseleave.native="
        $device.$isMobile ? null : handleArrowEvent('outside')
      "
      :prefetch="false"
    >
      <div class="d-flex-row justify-start flex-1">
        <NuxtImg
          v-if="!$isMobile() && logoText"
          :src="logoText"
          alt="Game logo text image"
          class="logo_img"
          fit="contain"
          background="transparent"
          quality="100"
          format="webp"
          :fetchpriority="preload ? 'high' : 'low'"
          :preload="preload"
        />
        <NuxtImg
          v-else-if="logoText"
          :src="logoText"
          alt="Game logo text image"
          class="logo_img"
          width="127"
          height="38"
          fit="contain"
          quality="100"
          background="transparent"
          format="webp"
          :preload="preload"
        />
      </div>

      <h1 class="stroked_text title-h1 font-family-1">
        {{ title }}
      </h1>

      <div class="arrow_right" v-if="!disabled" ref="arrow_right">
        <h4
          class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
          ref="arrow_right_text"
        >
          {{ $t("main.buy_now") }}
        </h4>
        <arrow-right />
      </div>

      <div class="arrow_right full_width" v-else-if="disabled">
        <p
          class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
        >
          {{ $t("missed.coming_soon") }}
        </p>
      </div>

      <NuxtImg
        :src="
          'https://cdn-assets.boostingmarket.com/games/' +
          slug +
          '/home_image.webp'
        "
        :alt="title + ' Game card image'"
        class="game_image"
        loading="eager"
      />
    </NuxtLinkLocale>
  </div>
</template>
<script setup>
import ArrowRight from "../icons/ArrowRight.vue";
import NewPackChip from "./NewPackChip.vue";
import { ref } from "vue";

const arrow_right = ref(null);
const arrow_right_text = ref(null);

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  slug: {
    type: String,
    default: "",
  },
  logoText: {
    type: String,
    default: "",
  },
  gameImage: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  link: {
    type: String,
    default: "",
  },
  index: {
    default: null,
  },
  hasNew: {
    default: false,
  },
  hasNewGame: {
    default: false,
  },
  preload: {
    default: true,
  },
});

const handleArrowEvent = (prompt) => {
  const el = arrow_right.value;
  const width = el?.getBoundingClientRect();
  const elText = arrow_right_text.value;
  const elWidth = elText?.getBoundingClientRect();
  if (!el) {
    return;
  }
  if (prompt === "outside") {
    el.style.width = "36px";
  }
  if (prompt === "inside") {
    const calWidth = elWidth.width + width.width + 12;
    el.style.width = `${calWidth}px`;
  }
};
</script>
